(function () {
  "use strict";
  /* mh: Muster-Begrenzung – max. 1 Stk. je Variante, max. 5 Muster gesamt.
     Fix 21.10.2026: erkennt Muster jetzt an _muster (muster-badge.js), _sample
     und am Produkttyp "…Muster…"; Korrektur per Line-Key statt Zeilen-Index. */
  var MAX_TOTAL = 5;
  var MSG_IN_CART = "Bereits im Warenkorb";
  var MSG_MAX = "Max. 5 Muster pro Bestellung";
  var enforcing = false;

  function isSample(item) {
    if (!item) return false;
    var p = item.properties || {};
    return p._muster === "1" || p._muster === 1 || p._muster === true ||
      p._sample === "true" || p._sample === true ||
      /muster/i.test(item.product_type || "");
  }
  function getCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }
  function stats(cart) {
    var total = 0, variantIds = {}, sampleLines = [];
    (cart.items || []).forEach(function (item, idx) {
      variantIds[item.variant_id] = true;
      if (isSample(item)) {
        total += item.quantity;
        sampleLines.push({ line: idx + 1, quantity: item.quantity });
      }
    });
    return { total: total, variantIds: variantIds, sampleLines: sampleLines };
  }
  function setNote(cta, text) {
    var note = cta.querySelector(".mh-sample__note");
    if (!note) {
      if (!text) return;
      note = document.createElement("p");
      note.className = "mh-sample__note";
      cta.appendChild(note);
    }
    note.textContent = text || "";
    note.style.display = text ? "" : "none";
  }
  function updateButtons(s) {
    document.querySelectorAll("[data-mh-sample-cta]").forEach(function (cta) {
      var vid = parseInt(cta.getAttribute("data-variant-id"), 10);
      var btn = cta.querySelector('button[name="add"]');
      if (!btn) return;
      if (cta.getAttribute("data-available") === "false") {
        btn.disabled = true; btn.setAttribute("aria-disabled", "true");
        return;
      }
      var inCart = !!s.variantIds[vid];
      var limit = s.total >= MAX_TOTAL;
      if (inCart || limit) {
        btn.disabled = true; btn.setAttribute("aria-disabled", "true");
        setNote(cta, inCart ? MSG_IN_CART : MSG_MAX);
      } else {
        btn.disabled = false; btn.removeAttribute("aria-disabled");
        setNote(cta, "");
      }
    });
  }
  /* UI: Plus-Button und Mengenfeld bei Muster-Zeilen sperren */
  function lockCartLines(s) {
    s.sampleLines.forEach(function (sl) {
      ["CartDrawer-Item-", "CartItem-"].forEach(function (prefix) {
        var el = document.getElementById(prefix + sl.line);
        if (!el) return;
        el.classList.add("mh-sample-line");
        var plus = el.querySelector('.quantity__button[name="plus"], button[name="plus"]');
        if (plus) { plus.setAttribute("disabled", "disabled"); }
        el.querySelectorAll('input[name="updates[]"], input[name="quantity"], .quantity__input').forEach(function (inp) {
          inp.setAttribute("max", "1");
          inp.setAttribute("readonly", "readonly");
        });
      });
    });
  }
  /* Regel durchsetzen: je Muster-Variante 1 Stk., gesamt max. MAX_TOTAL.
     Ueberzaehlige Zeilen werden auf 0 gesetzt (Reihenfolge = Warenkorb-Reihenfolge). */
  function enforce(cart) {
    if (enforcing) return;
    var remaining = MAX_TOTAL, seen = {}, updates = {}, dirty = false;
    (cart.items || []).forEach(function (item) {
      if (!isSample(item)) return;
      var target = (!seen[item.variant_id] && remaining > 0) ? 1 : 0;
      seen[item.variant_id] = true;
      remaining -= target;
      if (item.quantity !== target) { updates[item.key] = target; dirty = true; }
    });
    if (!dirty) return;
    enforcing = true;
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) { return r.json(); }).then(function () {
      document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { open: false } }));
    }).catch(function () {}).finally(function () {
      setTimeout(function () { enforcing = false; refresh(); }, 1000);
    });
  }
  var t;
  function refresh() {
    clearTimeout(t);
    t = setTimeout(function () {
      getCart().then(function (cart) {
        if (!cart) return;
        var s = stats(cart);
        updateButtons(s);
        lockCartLines(s);
        enforce(cart);
      });
    }, 120);
  }
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form || !form.closest) return;
    var cta = form.closest("[data-mh-sample-cta]");
    if (!cta) return;
    var btn = form.querySelector('button[name="add"]');
    if (btn && (btn.disabled || btn.getAttribute("aria-disabled") === "true")) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener("cart:updated", refresh);
  document.addEventListener("product-ajax:added", refresh);
  document.addEventListener("DOMContentLoaded", refresh);
  (function subPub(tries) {
    if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.subscribe && FoxTheme.pubsub.PUB_SUB_EVENTS) {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function () { refresh(); });
    } else if (tries < 100) {
      setTimeout(function () { subPub(tries + 1); }, 100);
    }
  })(0);
  refresh();
})();
